// Update checker for PWA

let swRegistration = null;

export const registerUpdateChecker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        swRegistration = registration;
        console.log('🔧 Service Worker ready for updates');

        // Check for updates every 5 minutes
        setInterval(() => {
          checkForUpdate();
        }, 5 * 60 * 1000);

        // Listen for new service worker
        registration.addEventListener('updatefound', () => {
          const newSW = registration.installing;
          console.log('📦 New service worker found');

          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('🔄 New version available!');
              showUpdateNotification();
            }
          });
        });
      })
      .catch(err => console.error('SW ready error:', err));

    // Also check on page load
    setTimeout(checkForUpdate, 3000);
  }
};

const checkForUpdate = async () => {
  if (!swRegistration) return;
  
  try {
    await swRegistration.update();
    console.log('📦 Checked for updates');
  } catch (error) {
    console.error('Error checking for updates:', error);
  }
};

const showUpdateNotification = () => {
  // Dispatch event for the UI to catch
  window.dispatchEvent(new CustomEvent('app-update-available'));
};

// Reload to update
export const reloadApp = () => {
  window.location.reload();
};

// Skip waiting and reload
export const forceUpdate = async () => {
  if (swRegistration && swRegistration.waiting) {
    await swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
    reloadApp();
  } else {
    reloadApp();
  }
};

// Check if update is available
export const isUpdateAvailable = () => {
  return localStorage.getItem('update_available') === 'true';
};
